<form [formGroup]="form" (ngSubmit)="sendFormData()">
  <h3>
    <title mat-dialog-title>{{ title }}</title>
  </h3>
  <sn-alert dense class="alert-left-aligned" type="danger" *ngIf="formErrors">
    <div *ngFor="let error of formErrors | keyvalue">
      <b>{{ error.key }}</b
      >: {{ error.value }}
    </div>
  </sn-alert>
  <mat-tab-group>
    <mat-tab [label]="'common.internal' | t">
      <mat-card-content>
        <mat-dialog-content>
          <sn-chat-user-select
            class="user-select-container"
            formControlName="users"
            [hasError]="HasUsersControlErrors"
            [exceptionList]="exceptionList"
            [type]="'direct'"
          >
          </sn-chat-user-select>
        </mat-dialog-content>
      </mat-card-content>
    </mat-tab>
    <mat-tab *ngIf="isExternalAllowed" [label]="'common.external' | t">
      <mat-card-content>
        <mat-form-field>
          <input #input matInput [placeholder]="'map.createChannel.emailAddress' | t" formControlName="email" />
        </mat-form-field>
        <mat-form-field>
          <input matInput [matDatepicker]="picker" formControlName="date" [placeholder]="'common.expires' | t" />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-hint>{{ 'map.createChannel.dateFormat' | t }}</mat-hint>
        </mat-form-field>
      </mat-card-content>
    </mat-tab>
  </mat-tab-group>
  <mat-dialog-actions>
    <button mat-button type="button" color="danger" (click)="cancel()">{{ 'common.close' | t }}</button>
    <button
      mat-button
      [disabled]="
        !form?.value?.users?.length && (!form?.value?.email || !form?.value?.email?.length)
      "
      type="submit"
      color="success"
      [mtBasicSpinner]="isLoading"
      [hideText]="true"
    >
      {{ 'common.submit' | t }}
    </button>
  </mat-dialog-actions>
</form>
